import { useRoutes } from "react-router-dom";

import mainRoutes from "./mainRoutes";
import authenticationRoutes from "./authenticationRoutes";

export default function AppRoutes() {
  return useRoutes([ mainRoutes, authenticationRoutes]);
}
